import { sodApi } from '@/services/index'

export const devopsApi = sodApi.injectEndpoints({
  endpoints: (builder) => ({
    saveDevOps: builder.mutation({
      query: ({ engagementId, data }) => ({
        url: `/DevOps/${engagementId}/create`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }),
    }),
    getDevOps: builder.query({
      query: ({ engagementId }) => ({
        url: `/DevOps/${engagementId}`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useSaveDevOpsMutation,
  useGetDevOpsQuery,
  useLazyGetDevOpsQuery,
} = devopsApi
